/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import type { GroupManagementUserGroupResponse } from "./GroupManagementUserGroupResponse";

export type GroupManagementUserGroupResponseApiRespoonse = {
  data?: GroupManagementUserGroupResponse;
  status?: GroupManagementUserGroupResponseApiRespoonse.status;
  message?: string;
  errors?: Record<string, Array<string>>;
};

export namespace GroupManagementUserGroupResponseApiRespoonse {
  export enum status {
    SUCCESS = "success",
    ERROR = "error",
  }
}
